import { graphql } from "gql.tada";
import { TitleSectionFragment } from "../fragments/TitleSectionFragment";
import { LinkFragment } from "../fragments/LinkFragment";

export const InspoCarouselSectionById = graphql(
  `
    query InspoCarouselSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      inspoCarouselSection(id: $id, preview: $preview, locale: $locale) {
        ...InspoCarouselSectionFragment
      }
    }

    fragment InspoCarouselSectionFragment on InspoCarouselSection {
      sys {
        id
      }
      titleSection {
        ...TitleSectionFragment
      }
      cta {
        ...LinkFragment
      }
      inspoCarouselItemsCollection(limit: 10) {
        items {
          sys {
            id
          }
          inspoCarouselTitle
          inspoCarouselSubtitle
          inspoCarouselSlideVideoUrl {
            url
          }
          a11YAriaLabel
        }
      }
      a11YPauseAriaLabel
    }
  `,
  [TitleSectionFragment, LinkFragment]
);
